import { forwardRef, ReactNode } from 'react';

import { Props as StackProps, Stack } from '../../../Stack/Stack';
import { Heading } from '../../../Typography/Heading/Heading';
import { Text } from '../../../Typography/Text/Text';
import { StyledSection } from './Section.styles';

interface Props extends Omit<StackProps, 'children'> {
	dark?: boolean;
	bordered?: boolean;
	title?: string;
	description?: string;
	action?: ReactNode;
	children?: ReactNode;
}

export const Section = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => (
	<StyledSection vertical element="section" {...props} ref={ref}>
		{(props.title || props.description || props.action) && (
			<Stack justify="between" spacing="loose">
				{(props.title || props.description) && (
					<Stack vertical>
						{props.title && <Heading element="h4">{props.title}</Heading>}
						{props.description && <Text color="subdued">{props.description}</Text>}
					</Stack>
				)}
				{props.action}
			</Stack>
		)}
		{children}
	</StyledSection>
));

Section.displayName = 'Section';
